<template>
  <div>
    <div class="banner wow animate__animated animate__fadeIn">
      <div class="manageList">
        <div class="manageItem" v-for="item in list" :key="item.key">
          <div class="m-t">
            <OssImg :src="item.iconPath" alt="" />
            <div>{{ item.title }}</div>
          </div>
          <div class="m-desc">
            {{ item.desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="scss" scoped>
.banner {
  margin-top: 32px;
  width: 100%;
  padding-bottom: 2rem;
  background-image: url("@/assets/images/bg/labBanner.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .manageList {
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    // align-items: center;
    .manageItem {
      width: 22%;
      height: 100%;
      position: relative;
      .m-t {
        position: absolute;
        top: 46px;
        display: flex;
        gap: 8px;
        align-items: center;
        color: #212121;
        font-weight: 500;
        font-size: 16px;
      }
      .m-desc {
        color: #888888;
        margin-top: 86px;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
}
</style>
